// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__ek3H5","modal":"Modal_modal__MUk1a","slide-down":"Modal_slide-down__JF5K3"};